import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import TitledLabel from '../../../controls/TitledLabel'
import { withStyles } from '@material-ui/core/styles'
import Columns from '../../../styles/columns'
import CardStyles from '../../../styles/cards'
import NgrxDate from '../../../util/NgrxDateHelper'
import { localize } from '../../../util/Localizer'
import CollapsibleSection from '../../../controls/CollapsibleSection'

const TransactionHistory = (props) => {
  const transactionHistory = props.transactionHistory
  return (
    <CollapsibleSection
      id='transactionHistory'
      showMuiBorder={false}
      heading={localize('pages.hcsa.transactionHistory')}
      expanded={false}>
      {transactionHistory.map((txn, index) => {
        return (
          <Card key={index} className={props.classes.hcsaCard}>
            <Row>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.hcsa.txnHist.transaction' value={txn.transaction} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.hcsa.txnHist.date' value={NgrxDate.SetDate(txn.transactionDate)} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.hcsa.txnHist.referenceNumber' value={txn.claimNumber} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.hcsa.txnHist.debit' value={txn.transDebit} format='currency' />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.hcsa.txnHist.credit' value={txn.transCredit} format='currency' />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.hcsa.txnHist.balance' value={txn.balance} format='currency' />
              </Col>
            </Row>
          </Card>
        )
      })}

    </CollapsibleSection>
  )
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(TransactionHistory)



// WEBPACK FOOTER //
// ./src/widgets/Member/Hsca/TransactionHistory.js